// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90ed8c43","453":"3985bf1b","667":"6eecb6f8","977":"572d66f7"}[chunkId] + ".chunk.js";
};